function home() {
  return '/'
}

const leaveRequest = '/leave-request'

function leaveRequestIndoTeam() {
  return `${leaveRequest}/indo-team`
}

function leaveRequestJapanTeam() {
  return `${leaveRequest}/japan-team`
}

function medicalReimbursement() {
  return '/medical-reimbursement'
}

const publicLink = {
  home,
  leaveRequestIndoTeam,
  leaveRequestJapanTeam,
  medicalReimbursement,
}

export default publicLink
